<template>
  <el-dialog
    title="Получить резервную копию"
    :visible="visible"
    width="30%"
    @update:visible="updateVisible">
    <p>Выберите базу и дату создания резервной копии</p>
    <div class="stack-sm">
      <el-select v-model="selectedDatabaseId" class="d-block mt-16" placeholder="База данных">
        <el-option
          v-for="base in databases"
          :key="base.id"
          :label="base.name"
          :value="base.id">
        </el-option>
      </el-select>
      <div v-if="selectedDatabaseId">
        <el-radio v-model="selectedBackupType" class="d-block" label="month">За последние 30 дней</el-radio>
        <el-date-picker
          v-model="selectedLastMonthDate"
          :disabled="selectedBackupType !== 'month'"
          :picker-options="{
            disabledDate: isDateDisabled
          }"
          class="d-block mt-8"
          type="date"
          placeholder="Выберите дату">
        </el-date-picker>
        <el-radio v-model="selectedBackupType" class="d-block mt-16" label="annual">Квартальные и годовые бекапы</el-radio>
        <el-select
          v-model="selectedAnnualDate" class="mt-8" :disabled="selectedBackupType !== 'annual'"
          placeholder="Выберите дату">
          <el-option
            v-for="backupDate in selectedDatabase.annualBackups"
            :key="backupDate"
            :label="formatDate(backupDate)"
            :value="backupDate">
          </el-option>
        </el-select>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        :loading="$mip('makeDatabaseBackup')"
        :disabled="!isFormFilled"
        type="primary"
        @click="sendBackupRequest">Отправить</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import { formatDate } from '@/utils'

  import { find } from 'lodash-es'

  export default {
    props: {
      visible: Boolean
    },

    data() {
      return {
        selectedBackupType: 'month', // month or annual
        selectedDatabaseId: '',
        selectedLastMonthDate: '',
        selectedAnnualDate: '',
        databases: []
      }
    },

    computed: {
      selectedDatabase() {
        return find(this.databases, { id: this.selectedDatabaseId })
      },

      selectedDatabaseMonthRange() {
        return this.selectedDatabase
          .lastMonthBackups
          .map(dateString => new Date(dateString))
      },

      isFormFilled() {
        return this.selectedDatabaseId &&
          this.selectedBackupType === 'month'
          ? this.selectedLastMonthDate
          : this.selectedAnnualDate
      }
    },

    async created() {
      this.databases = (await this.$http.getDatabasesToBackup()).data
    },

    methods: {
      formatDate,
      async sendBackupRequest() {
        await this.$http.makeDatabaseBackup({
          databaseId: this.selectedDatabaseId,
          date: this.selectedBackupType === 'month' ? this.selectedLastMonthDate : this.selectedAnnualDate
        })

        this.updateVisible(false)

        this.$msgbox({
          title: 'Заявка на создание базы отправлена',
          message: 'На создание базы потребуется определенное время. Для уточнения с вами свяжется наш менеджер',
          confirmButtonText: 'Отлично',
          type: 'info'
        })
      },

      updateVisible(val) {
        this.$emit('update:visible', val)
      },

      isDateDisabled(date) {
        const [
          leftEdge,
          rightEdge
        ] = this.selectedDatabaseMonthRange

        return !(leftEdge <= date && date <= rightEdge)
      }
    }
  }
</script>